import { render, staticRenderFns } from "./detail-component-date.vue?vue&type=template&id=2486c2bb&scoped=true"
import script from "./detail-component-date.vue?vue&type=script&lang=ts"
export * from "./detail-component-date.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2486c2bb",
  null
  
)

export default component.exports